(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-exploded-map"] && !Shopify.designMode) return;
  try {
    
  class ExplodedMap extends HTMLElement {
    connectedCallback() {
      this.image = this.querySelector('[data-map-image]');
      this.overlay = this.querySelector('[data-map-overlay]');
      this.dialog = this.querySelector('[data-map-dialog]');
      this.panel = this.querySelector('[data-map-panel]');
      this.nav = this.querySelector('[data-map-nav]');
      this.productCache = new Map();
      this.productIdCache = new Map();
      this.variantProductCache = new Map();
      this.currentProduct = null;
      this.currentVariant = null;
      this.currentChoices = [];
      this.labels = {
        addToCart: this.dataset.labelAddToCart,
        added: this.dataset.labelAdded,
        quantity: this.dataset.labelQuantity,
        partno: this.dataset.labelPartno,
        descriptionMore: this.dataset.labelDescriptionMore,
        descriptionLess: this.dataset.labelDescriptionLess,
        soldOut: this.dataset.labelSoldOut,
        unavailable: this.dataset.labelUnavailable,
        variant: this.dataset.labelVariant,
        loading: this.dataset.labelLoading,
        empty: this.dataset.labelEmpty,
        unavailableMapped: this.dataset.labelUnavailableMapped,
        error: this.dataset.labelError,
        nav: this.dataset.labelNav,
      };
      this.map = this.readMap();
      this.readProducts();
      this.panel.addEventListener('click', this.onPanelClick.bind(this));
      this.panel.addEventListener('change', this.onPanelChange.bind(this));
      if (this.dialog) this.dialog.addEventListener('click', this.onDialogClick.bind(this));
      this.render();
      this.renderContextNavigation();
    }

    renderContextNavigation() {
      if (!this.nav) return;

      const parentHandle = this.getParentContextHandle();
      const navData = parentHandle ? this.getStoredNavigation(parentHandle) : null;
      const items = navData && Array.isArray(navData.items) ? navData.items.filter((item) => item && item.handle && item.url) : [];

      if (!parentHandle || items.length < 2) {
        this.nav.hidden = true;
        this.nav.innerHTML = '';
        return;
      }

      const currentHandle = this.dataset.collectionHandle || '';
      this.nav.setAttribute('aria-label', this.labels.nav || '');
      this.nav.innerHTML = items.map((item) => {
        const active = item.handle === currentHandle;
        const url = this.withParentContext(item.url, parentHandle, navData.parentId);
        const image = item.image ? `<img src="${this.escapeAttribute(item.image)}" alt="${this.escapeAttribute(item.title)}" loading="lazy">` : `<span class="exploded-map__rail-placeholder">${this.escape((item.title || '?').slice(0, 1))}</span>`;
        return `
          <a class="exploded-map__rail-link${active ? ' is-active' : ''}" href="${this.escapeAttribute(url)}" title="${this.escapeAttribute(item.title)}" ${active ? 'aria-current="page"' : ''}>
            ${image}
            <span class="exploded-map__rail-text">${this.escape(item.title)}</span>
          </a>
        `;
      }).join('');
      this.nav.hidden = false;
    }

    getParentContextHandle() {
      const params = new URLSearchParams(window.location.search);
      return params.get('exploded_parent') || '';
    }

    getStoredNavigation(parentHandle) {
      const key = `radne:exploded-nav:${parentHandle}`;
      const sources = [];

      try {
        sources.push(window.sessionStorage);
      } catch (error) {}

      try {
        sources.push(window.localStorage);
      } catch (error) {}

      for (const source of sources) {
        try {
          const value = source.getItem(key);
          if (!value) continue;
          const data = JSON.parse(value);
          if (data && data.parentHandle === parentHandle) return data;
        } catch (error) {}
      }

      return null;
    }

    withParentContext(url, parentHandle, parentId) {
      try {
        const nextUrl = new URL(url, window.location.origin);
        nextUrl.searchParams.set('exploded_parent', parentHandle);
        if (parentId) nextUrl.searchParams.set('exploded_parent_id', parentId);
        return `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`;
      } catch (error) {
        return url;
      }
    }

    readMap() {
      const script = this.querySelector('[data-map-json]');
      if (!script) return null;

      try {
        let data = JSON.parse(script.textContent.trim() || 'null');
        if (typeof data === 'string') data = JSON.parse(data);
        if (data && typeof data.value === 'string') data = JSON.parse(data.value);
        if (data && Array.isArray(data.areas)) return data;
      } catch (error) {
        console.warn('Exploded map could not be parsed', error);
      }

      return null;
    }

    readProducts() {
      const script = this.querySelector('[data-products-json]');
      if (!script) return;

      try {
        const products = JSON.parse(script.textContent.trim() || '{}');
        Object.keys(products).forEach((handle) => {
          const product = products[handle];
          const productId = this.idFromGid(product && product.id);
          this.productCache.set(this.cleanProductHandle(handle), product);
          if (productId) this.productIdCache.set(String(productId), product);
          if (product && Array.isArray(product.variants)) {
            product.variants.forEach((variant) => {
              const variantId = this.idFromGid(variant && variant.id);
              if (variantId) this.variantProductCache.set(String(variantId), product);
            });
          }
        });
      } catch (error) {
        console.warn('Exploded map products could not be parsed', error);
      }
    }

    render() {
      if (!this.map || !this.map.imageUrl) {
        this.panel.innerHTML = `<div class="exploded-map__panel-empty">${this.escape(this.labels.empty)}</div>`;
        return;
      }

      this.image.src = this.map.imageUrl;
      this.image.alt = this.dataset.imageAlt || '';
      this.overlay.innerHTML = '';
      this.map.areas.forEach((area, index) => {
        const hotspot = this.createHotspot(area, index);
        if (hotspot) this.overlay.appendChild(hotspot);
      });
    }

    createHotspot(area, index) {
      if (!area || !Array.isArray(area.points) || !area.points.length) return null;

      const namespace = 'http://www.w3.org/2000/svg';
      const group = document.createElementNS(namespace, 'g');
      const title = area.label || area.productTitle || area.callout || String(index + 1);
      const point = this.getLabelPoint(area);

      group.classList.add('exploded-map__hotspot');
      group.setAttribute('role', 'button');
      group.setAttribute('tabindex', '0');
      group.setAttribute('aria-label', title);
      group.setAttribute('title', title);

      const nativeTitle = document.createElementNS(namespace, 'title');
      nativeTitle.textContent = title;
      group.appendChild(nativeTitle);

      if (area.shape === 'polygon' && area.points.length > 2) {
        const polygon = document.createElementNS(namespace, 'polygon');
        polygon.classList.add('exploded-map__polygon');
        polygon.setAttribute('points', area.points.map((item) => `${this.cleanNumber(item.x)},${this.cleanNumber(item.y)}`).join(' '));
        group.appendChild(polygon);
      } else {
        const ring = document.createElementNS(namespace, 'circle');
        ring.classList.add('exploded-map__ring');
        ring.setAttribute('cx', this.cleanNumber(point.x));
        ring.setAttribute('cy', this.cleanNumber(point.y));
        ring.setAttribute('r', '2.35');
        group.appendChild(ring);

        const circle = document.createElementNS(namespace, 'circle');
        circle.classList.add('exploded-map__circle');
        circle.setAttribute('cx', this.cleanNumber(point.x));
        circle.setAttribute('cy', this.cleanNumber(point.y));
        circle.setAttribute('r', '1.95');
        group.appendChild(circle);
      }

      group.addEventListener('click', () => this.selectArea(area, group));
      group.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.selectArea(area, group);
        }
      });

      return group;
    }

    getLabelPoint(area) {
      const points = area.points.map((point) => ({x: Number(point.x) || 0, y: Number(point.y) || 0}));
      if (area.shape !== 'polygon' || points.length < 3) return points[0];
      const total = points.reduce((sum, point) => ({x: sum.x + point.x, y: sum.y + point.y}), {x: 0, y: 0});
      return {x: total.x / points.length, y: total.y / points.length};
    }

    cleanNumber(value) {
      const number = Number(value);
      return Number.isFinite(number) ? String(Math.max(0, Math.min(100, number))) : '0';
    }

    selectArea(area, hotspot) {
      this.querySelectorAll('.exploded-map__hotspot.is-active').forEach((item) => item.classList.remove('is-active'));
      hotspot.classList.add('is-active');
      this.currentProduct = null;
      this.currentVariant = null;
      this.currentChoices = [];
      this.panel.innerHTML = `<div class="exploded-map__panel-loading">${this.escape(this.labels.loading)}</div>`;
      this.openDialog();

      const productRefs = this.getAreaProductRefs(area);

      if (!productRefs.length) {
        this.renderAreaOnly(area);
        return;
      }

      if (productRefs.length > 1) {
        this.getProductChoices(productRefs)
          .then((choices) => this.renderProductChoices(area, choices))
          .catch((error) => {
            console.warn('Exploded map product choices failed', {area: area, error: error});
            this.renderUnavailableArea(area);
          });
        return;
      }

      this.loadProductRef(productRefs[0])
        .then((product) => {
          this.showProduct(productRefs[0], product);
        })
        .catch((error) => {
          console.warn('Exploded map product lookup failed', {
            productHandle: productRefs[0].productHandle,
            productId: productRefs[0].productId,
            variantId: productRefs[0].variantId,
            area: area,
            error: error,
          });
          this.renderUnavailableArea(productRefs[0]);
        });
    }

    getAreaProductRefs(area) {
      const productList = Array.isArray(area && area.links) ? area.links : Array.isArray(area && area.products) ? area.products : Array.isArray(area && area.items) ? area.items : Array.isArray(area && area.productRefs) ? area.productRefs : [];
      if (productList.length) {
        return productList.map((item) => this.normalizeProductRef(item, area)).filter((item) => this.hasProductRef(item));
      }

      const directRef = this.normalizeProductRef(area, area);
      return this.hasProductRef(directRef) ? [directRef] : [];
    }

    normalizeProductRef(item, area) {
      area = area || {};
      const ref = typeof item === 'string' ? {productHandle: item} : Object.assign({}, item || {});
      ref.callout = ref.callout || area.callout;
      ref.label = ref.label || ref.productTitle || area.label || area.productTitle || area.callout;
      ref.productTitle = ref.productTitle || ref.label;
      ref.productHandle = ref.productHandle || ref.handle || ref.product_handle || ref.url;
      ref.productId = ref.productId || ref.product_id;
      ref.variantId = ref.variantId || ref.variant_id;
      ref.variantTitle = ref.variantTitle || ref.variant_title;
      return ref;
    }

    hasProductRef(ref) {
      return Boolean(ref && (ref.productHandle || ref.productId || ref.variantId));
    }

    getProductChoices(productRefs) {
      return Promise.all(productRefs.map((ref) => {
        return this.loadProductRef(ref)
          .then((product) => ({ref: ref, product: product, error: null}))
          .catch((error) => ({ref: ref, product: null, error: error}));
      }));
    }

    loadProductRef(ref) {
      return this.getProduct(ref);
    }

    showProduct(ref, product) {
      this.currentProduct = product;
      this.currentVariant = this.getInitialVariant(product, ref.variantId);
      this.renderProduct(ref, product);
    }

    renderProductChoices(area, choices) {
      this.currentChoices = choices;
      const title = area.label || area.productTitle || area.callout || this.labels.empty;
      const items = choices.map((choice, index) => this.renderProductChoice(choice, index)).join('');

      this.panel.innerHTML = `
        <div class="exploded-map__choices">
          <h3 class="exploded-map__choices-title">${this.escape(title)}</h3>
          <div class="exploded-map__choices-list">
            ${items}
          </div>
        </div>
      `;
    }

    renderProductChoice(choice, index) {
      const product = choice.product;
      const ref = choice.ref || {};
      const title = product && product.title ? product.title : ref.label || ref.productTitle || this.labels.unavailable;
      const image = product ? this.getProductImage(product, this.getInitialVariant(product, ref.variantId)) : '';
      const media = image
        ? `<img src="${this.escapeAttribute(image)}" alt="${this.escapeAttribute(title)}" loading="lazy">`
        : `<span class="exploded-map__choice-placeholder">${this.escape(this.labels.unavailable)}</span>`;

      return `
        <button class="exploded-map__choice" type="button" data-map-product-choice="${index}">
          <span class="exploded-map__choice-media">${media}</span>
          <span class="exploded-map__choice-title">${this.escape(title)}</span>
        </button>
      `;
    }

    selectProductChoice(index) {
      const choice = this.currentChoices[Number(index)];
      if (!choice) return;

      if (!choice.product) {
        this.renderUnavailableArea(choice.ref || {});
        return;
      }

      this.showProduct(choice.ref, choice.product);
    }

    getProduct(area) {
      const handle = this.cleanProductHandle(area && area.productHandle);
      const cachedProduct = this.getCachedProduct(handle, area && area.productId, area && area.variantId);
      if (cachedProduct) return Promise.resolve(cachedProduct);
      if (!handle) return this.getVariantProduct(area);

      const root = window.theme && window.theme.routes && window.theme.routes.root ? window.theme.routes.root : '/';
      const encodedHandle = encodeURIComponent(handle);
      const urls = [
        `${root}products/${encodedHandle}.js`,
        `/products/${encodedHandle}.js`,
        `${root}products/${encodedHandle}.json`,
        `/products/${encodedHandle}.json`,
      ];

      return this.fetchFirstProductUrl(urls)
        .then((product) => {
          const normalizedProduct = this.normalizeProductData(product);
          if (!normalizedProduct) throw new Error('Product data could not be normalized');
          this.productCache.set(handle, normalizedProduct);
          return normalizedProduct;
        })
        .catch((error) => {
          return this.getVariantProduct(area).catch(() => {
            throw error;
          });
        });
    }

    getVariantProduct(area) {
      const variantId = this.idFromGid(area && area.variantId);
      if (!variantId) return Promise.reject(new Error('Missing variant id'));

      const root = window.theme && window.theme.routes && window.theme.routes.root ? window.theme.routes.root : '/';
      const urls = [`${root}variants/${variantId}.js`, `/variants/${variantId}.js`];
      return this.fetchFirstProductUrl(urls).then((data) => this.productFromVariantData(area, data));
    }

    normalizeProductData(data) {
      const product = data && data.product ? data.product : data;
      if (!product || !Array.isArray(product.variants)) return null;
      product.handle = this.cleanProductHandle(product.handle || product.url);
      product.url = product.url || (product.handle ? `/products/${product.handle}` : '');
      product.description = this.stripHtml(product.description || product.body_html || '');
      product.featured_image = this.imageSource(product.featured_image);
      product.images = Array.isArray(product.images) ? product.images.map((image) => this.imageSource(image)).filter(Boolean) : [];
      product.variants = product.variants.map((variant) => this.normalizeVariantData(variant));
      return product;
    }

    productFromVariantData(area, data) {
      const variantData = data && data.variant ? data.variant : data;
      const variant = this.normalizeVariantData(variantData, area);
      const handle = this.cleanProductHandle(area && area.productHandle);
      const image = this.imageSource(variant.featured_image || variantData.featured_image || variantData.image);
      return {
        id: this.idFromGid(area && area.productId) || variantData.product_id || '',
        handle: handle,
        title: area.productTitle || area.label || variantData.product_title || variantData.name || variant.title || this.labels.unavailable,
        url: handle ? `/products/${handle}` : '',
        available: variant.available,
        featured_image: image,
        images: image ? [image] : [],
        variants: [variant],
      };
    }

    normalizeVariantData(variant, area) {
      const fallbackId = this.idFromGid(area && area.variantId);
      return {
        id: this.idFromGid(variant && variant.id) || fallbackId || (variant && variant.id),
        title: variant && variant.title ? variant.title : area && area.variantTitle ? area.variantTitle : 'Default Title',
        public_title: variant && (variant.public_title || variant.title) ? (variant.public_title || variant.title) : area && area.variantTitle ? area.variantTitle : 'Default Title',
        available: variant && typeof variant.available !== 'undefined' ? variant.available : true,
        price: variant && typeof variant.price !== 'undefined' ? variant.price : '',
        mpn: variant && variant.mpn ? variant.mpn : '',
        featured_image: {src: this.imageSource(variant && (variant.featured_image || variant.image))},
      };
    }

    imageSource(image) {
      if (!image) return '';
      if (typeof image === 'string') return image;
      return image.src || image.url || '';
    }

    getCachedProduct(handle, productId, variantId) {
      const numericProductId = this.idFromGid(productId);
      const numericVariantId = this.idFromGid(variantId);
      if (handle && this.productCache.has(handle)) return this.productCache.get(handle);
      if (numericProductId && this.productIdCache.has(String(numericProductId))) return this.productIdCache.get(String(numericProductId));
      if (numericVariantId && this.variantProductCache.has(String(numericVariantId))) return this.variantProductCache.get(String(numericVariantId));
      return null;
    }

    fetchFirstProductUrl(urls) {
      const [url, ...rest] = urls;

      return fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error(`Product request failed: ${url}`);
          return response.json();
        })
        .catch((error) => {
          if (!rest.length) throw error;
          return this.fetchFirstProductUrl(rest);
        });
    }

    getInitialVariant(product, variantId) {
      const numericVariantId = this.idFromGid(variantId);
      const variants = Array.isArray(product.variants) ? product.variants : [];
      if (numericVariantId) {
        const requested = variants.find((variant) => Number(variant.id) === numericVariantId);
        if (requested) return requested;
      }
      return variants.find((variant) => variant.available) || variants[0] || null;
    }

    idFromGid(value) {
      if (!value) return null;
      const parts = String(value).split('/');
      const number = Number(parts[parts.length - 1]);
      return Number.isFinite(number) ? number : null;
    }

    cleanProductHandle(value) {
      let handle = String(value || '').trim();
      if (!handle) return '';
      if (handle.indexOf('/products/') !== -1) handle = handle.split('/products/').pop();
      return handle.split('?')[0].split('#')[0].replace(/^\/+|\/+$/g, '');
    }

    renderAreaOnly(area) {
      this.panel.innerHTML = `
        <div class="exploded-map__product">
          <h3 class="exploded-map__product-title">${this.escape(area.label || area.productTitle || this.labels.unavailable)}</h3>
        </div>
      `;
    }

    renderUnavailableArea(area) {
      this.panel.innerHTML = `
        <div class="exploded-map__product">
          <h3 class="exploded-map__product-title">${this.escape(area.label || area.productTitle || this.labels.unavailable)}</h3>
          <div class="exploded-map__panel-error">${this.escape(this.labels.unavailableMapped)}</div>
        </div>
      `;
    }

    openDialog() {
      if (!this.dialog) return;
      this.positionDialogInViewport();
      if (typeof this.dialog.showModal === 'function') {
        if (!this.dialog.open) this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
    }

    positionDialogInViewport() {
      if (!this.dialog || !window.visualViewport || window.visualViewport.scale <= 1.05) {
        this.clearDialogViewportPosition();
        return;
      }

      const viewport = window.visualViewport;
      const scale = viewport.scale || 1;
      this.dialog.classList.add('is-viewport-positioned');
      this.dialog.style.setProperty('--exploded-dialog-left', `${viewport.offsetLeft + viewport.width / 2}px`);
      this.dialog.style.setProperty('--exploded-dialog-top', `${viewport.offsetTop + viewport.height / 2}px`);
      this.dialog.style.setProperty('--exploded-dialog-width', `${viewport.width * scale}px`);
      this.dialog.style.setProperty('--exploded-dialog-height', `${viewport.height * scale}px`);
      this.dialog.style.setProperty('--exploded-dialog-scale', String(1 / scale));
    }

    clearDialogViewportPosition() {
      if (!this.dialog) return;
      this.dialog.classList.remove('is-viewport-positioned');
      this.dialog.style.removeProperty('--exploded-dialog-left');
      this.dialog.style.removeProperty('--exploded-dialog-top');
      this.dialog.style.removeProperty('--exploded-dialog-width');
      this.dialog.style.removeProperty('--exploded-dialog-height');
      this.dialog.style.removeProperty('--exploded-dialog-scale');
    }

    closeDialog() {
      if (!this.dialog) return;
      if (typeof this.dialog.close === 'function') {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
      }
      this.clearDialogViewportPosition();
    }

    renderProduct(area, product) {
      const variant = this.currentVariant;
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const image = this.getProductImage(product, variant);
      const canAdd = Boolean(variant && variant.available);

      this.panel.innerHTML = `
        <div class="exploded-map__product">
          ${image ? `<a class="exploded-map__product-media" href="${this.escapeAttribute(product.url)}"><img src="${this.escapeAttribute(image)}" alt="${this.escapeAttribute(product.title)}" loading="lazy"></a>` : ''}
          <div class="exploded-map__product-info">
            <h3 class="exploded-map__product-title"><a href="${this.escapeAttribute(product.url)}">${this.escape(product.title)}</a></h3>
            <div class="exploded-map__price" data-map-price>${variant ? this.formatMoney(variant.price) : ''}</div>
            <div class="exploded-map__mpn" data-map-mpn ${variant && variant.mpn ? '' : 'hidden'}>${this.renderMpn(variant)}</div>
          </div>
          ${this.renderDescription(product)}
          ${variants.length > 1 ? this.renderVariantSelect(variants, variant) : ''}
          <div class="exploded-map__actions">
            <div class="exploded-map__quantity">
              <label class="exploded-map__quantity-label" for="ExplodedMapQuantity">${this.escape(this.labels.quantity)}</label>
              <div class="exploded-map__quantity-control">
                <button type="button" data-map-decrease aria-label="${this.escapeAttribute(this.labels.quantity)}">-</button>
                <input id="ExplodedMapQuantity" type="number" min="1" value="1" inputmode="numeric" data-map-quantity>
                <button type="button" data-map-increase aria-label="${this.escapeAttribute(this.labels.quantity)}">+</button>
              </div>
            </div>
            <button class="exploded-map__add btn btn--primary btn--solid" type="button" data-map-add ${canAdd ? '' : 'disabled'}>
              <span data-map-add-text>${this.escape(canAdd ? this.labels.addToCart : this.labels.soldOut)}</span>
            </button>
          </div>
          <div class="exploded-map__status" data-map-status></div>
        </div>
      `;
    }

    renderVariantSelect(variants, selectedVariant) {
      const options = variants.map((variant) => {
        const selected = selectedVariant && Number(selectedVariant.id) === Number(variant.id) ? ' selected' : '';
        const disabled = variant.available ? '' : ' disabled';
        const title = variant.public_title || variant.title;
        return `<option value="${this.escapeAttribute(String(variant.id))}"${selected}${disabled}>${this.escape(title)}</option>`;
      }).join('');

      return `
        <div class="exploded-map__variant">
          <label for="ExplodedMapVariant">${this.escape(this.labels.variant)}</label>
          <select id="ExplodedMapVariant" data-map-variant>${options}</select>
        </div>
      `;
    }

    onPanelChange(event) {
      if (!event.target.matches('[data-map-variant]') || !this.currentProduct) return;
      const variantId = Number(event.target.value);
      const variant = this.currentProduct.variants.find((item) => Number(item.id) === variantId);
      if (!variant) return;

      this.currentVariant = variant;
      const image = this.panel.querySelector('.exploded-map__product-media img');
      const price = this.panel.querySelector('[data-map-price]');
      const mpn = this.panel.querySelector('[data-map-mpn]');
      const add = this.panel.querySelector('[data-map-add]');
      const addText = this.panel.querySelector('[data-map-add-text]');
      const imageUrl = this.getProductImage(this.currentProduct, variant);
      if (image && imageUrl) image.src = imageUrl;
      if (price) price.textContent = this.formatMoney(variant.price);
      if (mpn) {
        mpn.hidden = !variant.mpn;
        mpn.innerHTML = this.renderMpn(variant);
      }
      if (add && addText) {
        add.disabled = !variant.available;
        addText.textContent = variant.available ? this.labels.addToCart : this.labels.soldOut;
      }
    }

    onPanelClick(event) {
      const choice = event.target.closest('[data-map-product-choice]');
      if (choice) {
        this.selectProductChoice(choice.dataset.mapProductChoice);
        return;
      }

      const quantityInput = this.panel.querySelector('[data-map-quantity]');
      if (event.target.closest('[data-map-decrease]') && quantityInput) quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) - 1));
      if (event.target.closest('[data-map-increase]') && quantityInput) quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) + 1));
      const add = event.target.closest('[data-map-add]');
      if (add) this.addToCart(add);
    }

    onDialogClick(event) {
      if (event.target.closest('[data-map-close]') || event.target === this.dialog) this.closeDialog();
    }

    addToCart(button) {
      if (!this.currentVariant || button.disabled) return;
      const quantityInput = this.panel.querySelector('[data-map-quantity]');
      const status = this.panel.querySelector('[data-map-status]');
      const text = this.panel.querySelector('[data-map-add-text]');
      const quantity = Math.max(1, Number(quantityInput ? quantityInput.value : 1) || 1);
      const cartAddUrl = window.theme && window.theme.routes && window.theme.routes.cart_add_url ? window.theme.routes.cart_add_url : '/cart/add.js';

      button.disabled = true;
      button.classList.add('is-loading');
      if (status) {
        status.textContent = '';
        status.classList.remove('is-error');
      }

      fetch(cartAddUrl, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({id: this.currentVariant.id, quantity: quantity}),
      })
        .then((response) => response.json().then((json) => {
          if (!response.ok || json.status) throw json;
          return json;
        }))
        .then(() => {
          if (text) text.textContent = this.labels.added;
          if (status) status.textContent = this.labels.added;
          document.dispatchEvent(new CustomEvent('theme:cart:refresh', {bubbles: true}));
          document.dispatchEvent(new CustomEvent('theme:cart:change', {bubbles: true}));
          setTimeout(() => {
            button.disabled = false;
            button.classList.remove('is-loading');
            if (text) text.textContent = this.labels.addToCart;
          }, 1400);
        })
        .catch((error) => {
          button.disabled = false;
          button.classList.remove('is-loading');
          if (status) {
            status.textContent = error && error.description ? error.description : this.labels.error;
            status.classList.add('is-error');
          }
        });
    }

    getProductImage(product, variant) {
      if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
      if (product.featured_image) return product.featured_image;
      if (Array.isArray(product.images) && product.images.length) return product.images[0];
      return '';
    }

    renderMpn(variant) {
      if (!variant || !variant.mpn) return '';
      return `${this.escape(this.labels.partno)}: <span>${this.escape(variant.mpn)}</span>`;
    }

    renderDescription(product) {
      const description = this.stripHtml(product && product.description);
      if (!description) return '';

      return `
        <details class="exploded-map__description">
          <summary>
            <span class="exploded-map__description-preview">${this.escape(description)}</span>
            <span class="exploded-map__description-toggle exploded-map__description-more">${this.escape(this.labels.descriptionMore)}</span>
            <span class="exploded-map__description-toggle exploded-map__description-less">${this.escape(this.labels.descriptionLess)}</span>
          </summary>
          <div class="exploded-map__description-full">${this.escape(description)}</div>
        </details>
      `;
    }

    stripHtml(value) {
      return String(value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    }

    formatMoney(value) {
      if (window.theme && typeof window.theme.formatMoney === 'function') return window.theme.formatMoney(value, window.theme.moneyFormat);
      return String(value);
    }

    escape(value) {
      return String(value || '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[character]));
    }

    escapeAttribute(value) {
      return this.escape(value);
    }
  }

  if (!customElements.get('exploded-map')) {
    customElements.define('exploded-map', ExplodedMap);
  }

  } catch(e) { console.error(e); }
})();
})();
